import React, { useState, useEffect } from "react";

import DatePicker from "react-datepicker";
import user from "../../assets/Report/user.svg";
import purple from "../../assets/Report/purpleRound.svg";
import grey from "../../assets/Report/greyRound.svg";
import { Dropdown } from "react-bootstrap";
import chevron_down from "../../assets/Vehicles/chevron_down.png";

import calender from "../../assets/Report/calender.svg";
import dottedCalender from "../../assets/Report/dotCalender.svg";
import assignedImg from "../../assets/Report/assigned.svg";
import typeImg from "../../assets/Report/vehicleType.svg";
import locationImg from "../../assets/Report/vechileLocation.svg";
import openWorkImg from "../../assets/Report/workOrder.svg";
import closedWorkImg from "../../assets/Report/closedWorkOrder.svg";
import inProgressWorkImg from "../../assets/Report/inprogressWorkOrder.svg";
import closedWorkImg2 from "../../assets/Report/assigned.svg";
import openServiceImg from "../../assets/Report/inprogressWorkOrder.svg";
import closedServiceImg from "../../assets/Report/clsoedServiceReminder.svg";
import openIssuesImg from "../../assets/Report/openIssues.svg";
import inProgressIssuesImg from "../../assets/Report/inprogressWorkOrder.svg";
import closedIssuesImg from "../../assets/Report/clsoedServiceReminder.svg";
import openRenewalImg from "../../assets/Report/openIssues.svg";
import closedRenewalImg from "../../assets/Report/inprogressWorkOrder.svg";
import { getButtonApi, getDatesApi, getExportApi, downloadBase64File } from "./report_api";
import { Toast, ToastContainer } from "react-bootstrap";
import CommonStaticDropdown from "../../components/common/common_static_dropdown";

import CommonDropdown from "../common/common_dropDown";

const imageMap = {
  monthly_report: dottedCalender,
  assigned_report: assignedImg,
  unassigned_report: dottedCalender,
  vehicle_type_report: typeImg,
  vehicle_location_report: locationImg,
  open_workorder_report: openWorkImg,
  vendor_report: closedWorkImg2,
  close_workorder_report: closedWorkImg,
  in_progress_workorder_report: inProgressWorkImg,
  close_workorder_report_2: closedWorkImg2,
  open_service_reminder: openServiceImg,
  close_service_reminder: closedServiceImg,
  open_issues: openIssuesImg,
  in_progress_issues: inProgressIssuesImg,
  close_issues: closedIssuesImg,
  open_renewal: openRenewalImg,
  close_renewal: closedRenewalImg,
};
export const Report = () => {
  const [selectVehicle, setSelectVehicle] = useState(null);
  const [selectDriver, setSelectDriver] = useState(null);
  const [selectVehicleType, setSelectVehicleType] = useState(null);
  const [selectStatus, setSelectStatus] = useState(null);
  const [selectUser, setSelectUser] = useState(null);

  const typeList = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];

  const resetSelections = () => {
    console.log("Before reset:", {
      selectVehicle,
      selectDriver,
      selectVehicleType,
      selectStatus,
      selectUser,
    });

    setSelectVehicle(null);
    setSelectDriver(null);
    setSelectVehicleType(null);
    setSelectStatus(null);
    setSelectUser(null);

    console.log("After reset:", {
      selectVehicle,
      selectDriver,
      selectVehicleType,
      selectStatus,
      selectUser,
    });
  };

  const handleSelectVehicle = (option) => {
    console.log("Selected option:", option);
    setSelectVehicle(option);
  };

  const handleSelectDriver = (option) => {
    console.log("Selected option:", option);
    setSelectDriver(option);
  };

  const handleSelectVechileType = (option) => {
    console.log("Selected option:", option);
    setSelectVehicleType(option);
  };

  const handleSelectStatus = (option) => {
    console.log("Selected option:", option);
    setSelectStatus(option);
  };

  const handleSelectUser = (option) => {
    console.log("Selected option:", option);
    setSelectUser(option);
  };
  const apiUrl = process.env.REACT_APP_API_URL;
  const [mode, setMode] = useState("quick");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  // button api
  const [cards, setCards] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedButton, setSelectedButton] = useState();
  useEffect(() => {
    const fetchCards = async () => {
      try {
        const result = await getButtonApi();
        const list = result?.data;
        // if (Array.isArray(list)) {
        setCards(
          list.map((item) => ({
            label: item.label,
            value: item.value,
            img: imageMap[item.value],
          }))
        );
        // }
      } catch (err) {
        console.error(err);
      }
    };

    fetchCards();
  }, []);

  // export api
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const response = await getExportApi(selectVehicleType, selectVehicle, selectDriver, selectStatus, selectUser, startDate, endDate);
      console.log("Export response:", response);

      if (response.status === 200) {
        console.log("inside success1");
        if (response.data.success === true) {
          console.log("inside success2");

          const base64String = response.data.base64;
          const fileName = response.data.file_name;

          if (base64String) {
            downloadBase64File(base64String, fileName);
          } else if (response.data.url) {
            window.open(response.data.url, "_blank");
          }
        }
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setIsExporting(false);
    }
  };

  //Quick Report
  const handleQuickReport = async (buttonValue) => {
    setIsExporting(true);
    try {
      const response = await getDatesApi(buttonValue, startDate, endDate);
      console.log("Export response:", response);

      if (response.status === 200) {
        if (response.data.success === true) {
          console.log("inside success2");

          const base64String = response.data.base64;
          const fileName = response.data.file_name;

          if (base64String) {
            downloadBase64File(base64String, fileName);
          } else if (response.data.url) {
            window.open(response.data.url, "_blank");
          }
        }
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <ToastContainer position="top-end">
          <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
            <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
        <div className="row p-3 p-xl-5 m-0">
          <div className="col-xl-4 d-flex flex-column align-items-start mb-3 mb-xl-0">
            <p className="fs-24 fw-700">Get your report easily</p>
            <p className="fs-15 fw-300 w-90">Use the customized export option to download your data with the applied filters for easy management. Exporting data also helps in maintaining accurate records and creating reliable backups.</p>
            <img src={user} alt="user" className="w-75 mt-4" />
          </div>
          <div className="col-xl-8">
            <div className="bg-white rounded-4 p-3">
              <div className="row m-0 mb-4">
                <div className="col-sm-6">
                  <button
                    className="btn rounded-pill w-100 gap-2 py-3 d-flex justify-content-center"
                    style={{
                      backgroundColor: mode === "custom" ? "#F2E0FF" : "white",
                    }}
                    onClick={() => setMode("custom")}
                  >
                    <img src={purple} alt="pruple" className={`${mode === "custom" ? "d-inline" : "d-none"}`} />
                    <img src={grey} alt="grey" className={`${mode === "quick" ? "d-inline" : "d-none"}`} />
                    Customized
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    className="btn rounded-pill w-100 gap-2 py-3 d-flex justify-content-center"
                    style={{
                      backgroundColor: mode === "quick" ? "#F2E0FF" : "white",
                    }}
                    onClick={() => setMode("quick")}
                  >
                    <img src={purple} alt="pruple" className={`${mode === "quick" ? "d-inline" : "d-none"}`} />
                    <img src={grey} alt="grey" className={`${mode === "custom" ? "d-inline" : "d-none"}`} />
                    Quick Report
                  </button>
                </div>
              </div>

              {mode === "quick" ? (
                <>
                  <div>
                    <p className="text-muted text-center mb-3 dotted-line">Just a single click is enough!</p>

                    <div className="d-flex flex-wrap gap-3 mb-4 justify-content-start justify-content-xl-center align-items-center">
                      <p className="m-0" style={{ color: "#626F86" }}>
                        Date Range :
                      </p>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        value={startDate}
                        dateFormat="dd-mm-yyyy"
                        customInput={
                          <button
                            style={{
                              color: "#8790A1",
                              width: "130px",
                              height: "35px",
                            }}
                            className="btn-border-grey vehicle-form-input bg-white rounded-3 px-2 d-flex justify-content-between align-items-center gap-1"
                          >
                            {startDate ? (
                              startDate.toLocaleDateString("en-GB").replace(/\//g, "-")
                            ) : (
                              <span style={{ color: "#8790A1" }} className="pe-0">
                                start
                              </span>
                            )}
                            <img src={calender} alt="calender" style={{ width: "16px", height: "16px" }} />
                          </button>
                        }
                      />
                      <span>-</span>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        value={endDate}
                        dateFormat="dd-mm-yyyy"
                        customInput={
                          <button
                            style={{
                              color: "#8790A1",
                              width: "130px",
                              height: "35px",
                            }}
                            className="btn-border-grey vehicle-form-input bg-white rounded-3 px-2 d-flex justify-content-between align-items-center gap-1"
                          >
                            {endDate ? (
                              endDate.toLocaleDateString("en-GB").replace(/\//g, "-")
                            ) : (
                              <span style={{ color: "#8790A1" }} className="pe-2">
                                End
                              </span>
                            )}
                            <img src={calender} alt="calender" style={{ width: "16px", height: "16px" }} />
                          </button>
                        }
                      />
                    </div>

                    <div className="row g-3">
                      {cards.map((item) => (
                        <div
                          key={item.value}
                          onClick={() => {
                            if (!isExporting) {
                              setSelectedButton(item.value);
                              handleQuickReport(item.value);
                            }
                          }}
                          className="col-md-4 col-sm-6"
                          style={{
                            cursor: isExporting ? "not-allowed" : "pointer",
                            opacity: isExporting ? 0.8 : 1,
                          }}
                        >
                          <div
                            className="p-3 fs-12 text-start rounded-4 d-flex align-items-center justify-content-between"
                            style={{
                              backgroundColor: "#F8F8F8",
                              color: "#172B4D",
                              minHeight: "56px",
                            }}
                          >
                            <div className="d-flex gap-2 align-items-center">
                              <img src={item.img} alt={item.label} />
                              {item.label}
                            </div>
                            {isExporting && selectedButton === item.value && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <div className="row g-3 mb-4">
                      <div className="col-xl-6">
                        <label className="form-label fw-400">Vehicle</label>
                        <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select Vehicle" value={selectVehicle} onSelect={handleSelectVehicle} />{" "}
                      </div>
                      <div className="col-xl-6">
                        <label className="form-label fw-400">Driver</label>
                        <CommonDropdown apiUrl={`${apiUrl}get_drivers`} placeholder="Select Driver" value={selectDriver} onSelect={handleSelectDriver} />
                      </div>
                      <div className="col-xl-6">
                        <label className="form-label fw-400">Vehicle type</label>
                        <CommonDropdown apiUrl={`${apiUrl}get_vehicletype`} placeholder="Select Vehicle type" value={selectVehicleType} onSelect={handleSelectVechileType} />
                      </div>
                      <div className="col-xl-6">
                        <label className="form-label fw-400">Status</label>
                        <CommonStaticDropdown items={typeList} placeholder="Select status" value={selectStatus} onSelect={handleSelectStatus} enableSearch={false} />
                      </div>
                      <div className="col-xl-6">
                        <label className="form-label fw-400">User name</label>
                        <CommonDropdown apiUrl={`${apiUrl}get_users`} placeholder="Select user name" value={selectUser} onSelect={handleSelectUser} />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between gap-3">
                      <button className="rounded-pill px-4 w-50 bg-white text-dark-purple py-3 fs-14 fw-700" style={{ border: "1px solid #EBEBEB" }} onClick={resetSelections}>
                        Reset
                      </button>
                      <button className="fs-14 rounded-pill px-4 w-50 dark-purple-btn py-3" onClick={handleExport} disabled={isExporting}>
                        {isExporting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Exporting...
                          </>
                        ) : (
                          "Export"
                        )}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
